import api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadFolderOffers(documentId, siteId) {
  return async (dispatch, getState) => {
    let loading = false,
      loaded = false;
    const key = `${documentId}-${siteId}`;
    const folderOffers = getState().document.decision.folderOffers[key];
    if (folderOffers) {
      loading = folderOffers.loading;
      loaded = folderOffers.loaded;
    }

    if (loading || loaded) return;

    dispatch({ type: actionTypes.LOAD_FOLDER_OFFERS_STARTED, id: key });
    try {
      let result = await dispatch(sendHttpRequest(api.getFolderOffers(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_FOLDER_OFFERS_SUCCEEDED, payload: result, id: key });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FOLDER_OFFERS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
